import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

const POLICY_KEY = ["academy-policy"];

// GET auto-creates the singleton in the backend if it doesn't exist yet.
function useAcademyPolicy() {
  return useQuery({
    queryKey: POLICY_KEY,
    queryFn: () => apiClient.get("/api/v1/academy-policy/").then((r) => r.data),
  });
}

function useUpdateAcademyPolicy() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      apiClient.patch("/api/v1/academy-policy/", body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: POLICY_KEY }),
  });
}

export { useAcademyPolicy, useUpdateAcademyPolicy, POLICY_KEY };
